import { CustomWindowType } from "../../types";

export function isWebPlatform(): boolean {
  const { webPlatform }: CustomWindowType = window;
  return webPlatform ?? false;
}
